var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJogging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5477 33.0918C29.5386 33.7647 28.3529 34.1237 27.1401 34.1237H23.6895",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6084 41.7562H33.9598C32.2062 41.7513 30.5257 41.0531 29.285 39.8138L10.8691 21.3086",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3275 19.4649L45.5503 7",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9208 45.9941H12.5001",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3596 18.082V30.8623",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2401 14.413L35.1969 21.4745L36.5968 33.7017C36.5968 34.9051 41.6441 38.9819 44.3655 40.8989C44.8517 41.2436 45.2156 41.7341 45.4047 42.2993C45.5938 42.8646 45.5982 43.4753 45.4172 44.0432C45.2363 44.6111 44.8794 45.1067 44.3982 45.4584C43.917 45.8101 43.3365 45.9996 42.7404 45.9996H32.6667C31.3773 45.9996 30.1006 45.7449 28.9099 45.2501C27.7192 44.7553 26.6379 44.0302 25.7282 43.1165L9.17144 27.05C8.88211 26.7693 8.65162 26.4337 8.49344 26.0628C8.33526 25.692 8.25256 25.2933 8.25018 24.8902C8.24779 24.487 8.32576 24.0874 8.47953 23.7147C8.6333 23.342 8.85979 23.0037 9.14578 22.7195L17.5736 14.3451C17.8562 14.0496 18.2298 13.8575 18.6345 13.7996C19.0392 13.7418 19.4516 13.8214 19.8057 14.0258C20.1417 14.2341 20.3976 14.5495 20.5321 14.9212C20.6666 15.2929 20.6719 15.699 20.547 16.0741L20.4176 16.4622C20.1813 17.1199 20.2124 17.844 20.5043 18.479C20.7398 18.9635 21.1231 19.3606 21.5987 19.6134C22.0744 19.8662 22.618 19.9615 23.1513 19.8857L27.5574 19.2562C28.2288 19.1603 28.9119 19.3151 29.4764 19.6911C30.0408 20.0671 30.4469 20.6378 30.6171 21.2943L33.1388 32.2817C33.3278 33.0108 35.0834 33.7962 36.5034 33.7962",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3301 7L38.3486 11.9948",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9663 11.2276L25.277 7L33.5516 15.846",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.793 21.752L28.5444 23.2083",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1213 24.9004L29.4933 26.2118",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4983 28.0938L30.5697 29.2424",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8804 42.6035H16.7281",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6417 38.3652H12.4894",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67468 40.9082H9.5224",
    stroke: "#BC8639",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJogging);
export default __webpack_public_path__ + "static/media/jogging.ccec9d1bf6d7f363fdab210948eb1b06.svg";
export { ForwardRef as ReactComponent };